module.exports = __webpack_public_path__ + "img/VA_logo.233d0893.png";